import { Routes, Route, Link, NavLink } from "react-router-dom";
import { useAuth } from "@/stores/authStore";
import { useCart } from "@/stores/cartStore";
import KatalogPage from "./pages/KatalogPage";
import KorbPage from "./pages/KorbPage";
import CheckoutPage from "./pages/CheckoutPage";
import MeineBestellungenPage from "./pages/MeineBestellungenPage";
import BestelldetailPage from "./pages/BestelldetailPage";
import MeinAboPage from "./pages/MeinAboPage";
import KontoPage from "./pages/KontoPage";

export default function ShopModule() {
  const signOut = useAuth((s) => s.signOut);
  const cartCount = useCart((s) => s.count());

  return (
    <div className="min-h-screen bg-hof-50">
      <header className="bg-white border-b border-hof-100 sticky top-0 z-10">
        <div className="max-w-4xl mx-auto px-4 py-3 flex items-center justify-between gap-2">
          <Link to="/shop" className="flex items-center gap-2 shrink-0">
            <img src="/logo-emblem.png" alt="" className="h-10" />
            <span className="font-brand font-bold text-xl text-wappen-700 hidden sm:inline">Hof Sirges</span>
          </Link>
          <nav className="flex items-center gap-1 flex-wrap">
            <ShopNav to="/shop">Hofladen</ShopNav>
            <ShopNav to="/shop/bestellungen">Bestellungen</ShopNav>
            <ShopNav to="/shop/abos">Mein Abo</ShopNav>
            <ShopNav to="/shop/konto">Konto</ShopNav>
            <Link
              to="/shop/korb"
              className="relative btn-secondary min-w-touch p-2"
              aria-label="Warenkorb"
            >
              🧺 {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-wiese-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">
                  {cartCount}
                </span>
              )}
            </Link>
            <button onClick={signOut} className="btn-ghost hidden md:inline-flex">Abmelden</button>
          </nav>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-6">
        <Routes>
          <Route index element={<KatalogPage />} />
          <Route path="korb" element={<KorbPage />} />
          <Route path="checkout" element={<CheckoutPage />} />
          <Route path="bestellungen" element={<MeineBestellungenPage />} />
          <Route path="bestellungen/:id" element={<BestelldetailPage />} />
          <Route path="abos" element={<MeinAboPage />} />
          <Route path="konto" element={<KontoPage />} />
        </Routes>
      </main>
    </div>
  );
}

function ShopNav({ to, children }: { to: string; children: React.ReactNode }) {
  return (
    <NavLink
      to={to}
      end
      className={({ isActive }) =>
        `px-3 py-2 rounded-xl min-h-touch inline-flex items-center ${
          isActive ? "bg-wiese-100 text-wiese-800 font-medium" : "text-hof-700 hover:bg-hof-100"
        }`
      }
    >
      {children}
    </NavLink>
  );
}

